import { createStore } from 'vuex'
import auth from './modules/auth'
import leads from './modules/leads'
import interactions from './modules/interactions'
import whatsapp from '../whatsapp/store/whatsapp.module'

export default createStore({
  state: {
    loading: false,
    error: null
  },
  mutations: {
    SET_LOADING(state, loading) {
      state.loading = loading
    },
    SET_ERROR(state, error) {
      state.error = error
    }
  },
  actions: {
    setLoading({ commit }, loading) {
      commit('SET_LOADING', loading)
    },
    setError({ commit }, error) {
      commit('SET_ERROR', error)
    }
  },
  modules: {
    auth,
    leads,
    interactions,
    whatsapp
  }
}) 